<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/So087P/tc-custom/9781949090079.jpg?1705231666001" alt="This image is the cover for the book Modern Knights Collection Books 1–3, The Modern Knights Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Modern Knights Collection Books 1–3, The Modern Knights Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The first 3 books in this “extremely impressive” urban fantasy series about a wizard-for-hire: “a fantastical thrill ride [with] stunning plot twists” (<i>Publishers Weekly</i>, starred review, on <i>Frostbite</i>).</b></p><p><b>FROSTBITE</b><br/> Harvard dropout Colin Fisher has a lot on his mind: a dying father, a dead car doubling as a home, and a mysteriously disappeared fiancée. But his luck seems ready to change when a billionaire CEO offers him a job as his personal wizard. It’s a sweet gig with a major catch: Colin’s boss is cursed. Now Colin is the only thing standing between a CEO and a cannibal ice demon.</p><p><b>TWO WIZARD ROULETTE</b><br/> As personal wizard to a multinational CEO, Colin's been busy with assassins, amnesia potions, and career criminals—not to mention the fact that his favorite FBI contact looks exactly like his missing, presumed dead, fiancé. But he’s about to get busier when a dangerous gambler with magical powers starts fleecing Vegas casinos for millions.</p><b>FACELESS</b><br/> To finally find out what happened to his fiancée on the night he gained his magic, Colin Fisher takes on his riskiest adventure yet. In a self-induced coma, he’s trying to peel back the layers of time and solve the enigma. Meanwhile, the two women who love him must work together to defeat an organization known as the Faceless and keep Colin safe while he’s on his spirit journey.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joshua Bader
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      City Owl Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4d45a6ca